import EventEmitter from 'events';
import CustomChannelClient from './customClient';
export class LocalServer extends EventEmitter.EventEmitter {
    constructor(version, customPackets, hideErrors = false) {
        super();
        this.version = version;
        this.customPackets = customPackets;
        this.hideErrors = hideErrors;
        this.socketServer = null;
        this.cipher = null;
        this.decipher = null;
        this.clients = {};
    }
    listen() {
        this.emit('connection', new CustomChannelClient(true, this.version));
    }
    close() { }
}
